export const navSidebar = [
  {
    label: "All Products",
    href: "/all-products",
    external: false,
  },
  {
    label: "Bottle Service",
    href: "/bottle-service/",
    external: false,
    children: [
      [
        {
          label: "Sparklers & Toppers",
          href: "/bottle-service/sparklers/",
          external: false,
          divider: false,
        },
        {
          label: "Bottle Presenters",
          href: "/bottle-service/bottle-presenters/",
          external: false,
          divider: false,
        },
        {
          label: "Stickers",
          href: "/bottle-service/stickers/",
          external: false,
          divider: false, 
        },
        {
          label: "Trays",
          href: "/bottle-service/trays/",
          external: false,
          divider: false, 
        },
      ],
    ],
  },
  {
    label: "Party Supplies",
    href: "/party-supplies/",
    external: false,
    children: [
      [
        {
          label: "Party Kits",
          href: "/party-supplies/party-kits/",
          external: false,
          divider: false,
        },
        {
          label: "Confetti Poppers",
          href: "/party-supplies/confetti-poppers",
          external: false,
          divider: false,
        },
        {
          label: "Ice Buckets",
          href: "/party-supplies/ice-buckets/",
          external: false,
          divider: false, 
        },
      ],
    ],
  },
  {
    label: "Menus & Signs",
    href: "/menus-and-signs/",
    external: false,
  },
  {
    label: "Soda Syrups",
    href: "/soda-syrups/",
    external: false,
  },
];
